import "./navbar.css";
import { NavLink, useNavigate } from "react-router-dom";
import Select, { type SelectItem } from "../select/Select";
import { ART } from "@/constant/routes";
import type { IconName } from "../icon/IconName";

interface NavbarProps {
    onClick?: () => void;
    displayName?: string;
    navbarItems?: {label: string, iconName?: IconName, link: string}[]
    options?: SelectItem[];
 }

export default function NavBar({displayName, options, navbarItems, ...props}: NavbarProps) {
    const navigate = useNavigate();
    const mobileNavItems = () => {
        let items = []

        navbarItems.map((navbarItem) => 
        items = [...items, {
            label: navbarItem.label,
            iconName: navbarItem.iconName,
            onClick : () => navigate(navbarItem.link),
        }])
        
        items = [...items, ...options]
       
        return items;
    }; 


    return (
        <header className="navbar">
            <div onClick={() => navigate(ART)} className="navbar-logo">
                <div className="navbar-logo-icon">
                    P
                </div>
                <div className="navbar-logo-text">
                    <span>Patrimoine</span>
                    <small>Management</small>
                </div>
            </div>
            {navbarItems && 
            <>
            <Select 
                className="navbar-mobile-menu" 
                iconName="menu"
                items={mobileNavItems()}
            />
            <div className="navbar-desktop-menu">
                <nav className="navbar-links">
                    {navbarItems.map((navbarItem) => 
                    <NavLink key={navbarItem.label} to={navbarItem.link}>{navbarItem.label}</NavLink>)}
                </nav>  
            </div></>}
            <div className="navbar-actions">
                {displayName && <Select label={displayName} items={options}/>}
            </div>
          
        </header>
    );

}